const SUBSCRIPTION_APPS = {
  recharge: "294517",
  skio: "SKIO",
};

document.addEventListener("alpine:init", () => {
  Alpine.data("CtrEnergyProductBox", () => ({
    mode: "subscribe",
    selectedVariant: null,
    fallbackSellingPlanId: null,
    subscriptionProvider: "recharge",
    mainProduct: {},
    subscriptionDataObj: { selling_plans: [] },
    activePlanIds: new Set(),
    selectedSellingPlanId: null,
    loading: false,
    variantMediaMap: {},
    sectionId: null,
    giftVariants: [],
    giftPropertyKey: '_offer',
    giftPropertyValue: 'free-gifts',
    insuredShippingVariant: null,
    redirectAfterAdd: 'checkout',
    variantData: {},
    productUrl: null,
    useVariantBg: false,
    bgFallback: '',
    galleryAbort: null,
    moneyFormat: '${{amount}}',
    sub3Enabled: false, // 3 pack product data loaded (used by subscribe3 and onetime3)
    sub3OptionEnabled: false,
    onetime3OptionEnabled: false,
    onetimeEnabled: true,
    sixPackServings: 30,
    threePackServings: 15,
    threePackUrl: null,
    templateSuffix: '',
    galleryKey: null,
    sub3Product: { variants: [] },
    sub3Plans: [],
    sub3PlanIds: new Set(),
    selectedSub3PlanId: null,
    // Updated layout (CNV-7113): allocation prices, frequency placeholder, checked add to cart.
    updatedLayout: false,
    planChosen: false,

    init() {
      this.updatedLayout = this.$el.dataset.layout === "updated";
      this.mode = this.$el.dataset.defaultMode || "subscribe";
      this.selectedVariant = this.parseNullableInt(
        this.$el.dataset.initialVariantId
      );
      this.fallbackSellingPlanId = this.parseNullableInt(
        this.$el.dataset.fallbackSellingPlanId
      );
      this.subscriptionProvider =
        this.$el.dataset.subscriptionProvider === "skio" ? "skio" : "recharge";
      this.sectionId = this.$el.dataset.sectionId || null;
      this.giftVariants = (this.$el.dataset.giftVariants || '')
        .split(',')
        .map(v => v.trim())
        .filter(v => v !== '');
      this.giftPropertyKey = this.$el.dataset.giftPropertyKey || '_offer';
      this.giftPropertyValue = this.$el.dataset.giftPropertyValue || 'free-gifts';
      this.insuredShippingVariant = this.parseNullableInt(this.$el.dataset.insuredShippingVariant);
      this.redirectAfterAdd = this.$el.dataset.redirectAfterAdd || 'checkout';

      this.parseVariantMediaMap();
      this.parseVariantData();
      this.productUrl = this.$el.dataset.productUrl || null;
      this.useVariantBg = this.$el.dataset.useVariantBg === 'true';
      this.bgFallback = this.$el.dataset.bgFallback || '';
      this.moneyFormat = this.$el.dataset.moneyFormat || '${{amount}}';
      // subscribe3 also needs the pack block's "Allow Subscribe & Save on 3 Pack" (Liquid).
      this.sub3OptionEnabled =
        this.$el.dataset.sub3Enabled === 'true' && this.$el.dataset.subscribe3Enabled !== 'false';
      this.onetime3OptionEnabled = this.$el.dataset.onetime3Enabled === 'true';
      this.onetimeEnabled = this.$el.dataset.onetimeEnabled !== 'false';
      this.sixPackServings = Number(this.$el.dataset.sixPackServings) || 30;
      this.threePackServings = Number(this.$el.dataset.threePackServings) || 15;
      this.sub3Enabled = this.$el.dataset.sub3Enabled === 'true';
      this.threePackUrl = this.$el.dataset.threePackUrl || null;
      this.templateSuffix = this.$el.dataset.templateSuffix || '';
      this.galleryKey = `main:${this.selectedVariant}`;
      if (this.sub3Enabled) this.parseSub3Product();
      if (!this.isModeEnabled(this.mode)) {
        this.mode = this.mode === 'subscribe3' && this.isModeEnabled('onetime3') ? 'onetime3' : 'subscribe';
      }
      if (this.isThreePackMode()) {
        this.ensureSub3Variant();
        this.$nextTick(() => this.renderGallery(this.selectedVariant));
      }
      // Default flavor (theme setting) can differ from product.selected_or_first_available_variant
      // used by other sections on load, so sync listeners once.
      if (this.selectedVariant && !new URL(window.location.href).searchParams.has('variant')) {
        this.$nextTick(() => this.dispatchVariantChange(this.selectedVariant));
      }
      this.parseSubscriptionProduct();
      this.loadSubscriptionPlans();
      this.setSellingPlanForVariant(this.selectedVariant);
       // Fix: reset loading state when navigating back from checkout (bfcache)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) this.loading = false;
  });
    },

    normalizePlanId(id) {
      if (id === undefined || id === null || id === "") return null;
      const parsed = Number(id);
      return Number.isFinite(parsed) ? parsed : id;
    },

    isProviderGroup(group, provider) {
      const appId = String(group?.app_id ?? "").toUpperCase();
      if (provider === "skio") {
        return appId === "SKIO" || appId.includes("SKIO");
      }
      return appId === "294517" || group?.app_id === 294517;
    },

    getActiveAppId() {
      return SUBSCRIPTION_APPS[this.subscriptionProvider] || SUBSCRIPTION_APPS.recharge;
    },

    parseNullableInt(value) {
      if (value === undefined || value === null || value === "") return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },

    parseSubscriptionProduct() {
      const rawJson = this.$refs.rechargeProductJson?.textContent;
      if (!rawJson) {
        this.mainProduct = {};
        return;
      }
      try {
        this.mainProduct = JSON.parse(rawJson);
      } catch (error) {
        console.error("[ctr-epb] subscription product parse error", error);
        this.mainProduct = {};
      }
    },

    loadSubscriptionPlans() {
      const normalized = this.buildSellingPlans(this.mainProduct);
      this.subscriptionDataObj = { selling_plans: normalized };
      this.activePlanIds = new Set(normalized.map((plan) => plan.id));
    },

    buildSellingPlans(product) {
      const provider = this.subscriptionProvider;
      const allGroups = product?.selling_plan_groups || [];
      let groups = allGroups.filter((g) => this.isProviderGroup(g, provider));

      // Skio: if app_id is not literally "SKIO", use any non-Recharge group
      if (provider === "skio" && groups.length === 0) {
        groups = allGroups.filter(
          (g) => String(g?.app_id ?? "") !== "294517" && g?.app_id !== 294517
        );
      }

      const allPlans = groups.flatMap((g) =>
        Array.isArray(g.selling_plans) ? g.selling_plans : []
      );

      const normalized = [];
      const seen = new Set();

      for (const plan of allPlans) {
        const planId = this.normalizePlanId(plan?.id);
        if (!plan || planId == null || seen.has(planId)) continue;
        seen.add(planId);

        const adjustment = plan.price_adjustments?.[0] || {};
        normalized.push({
          id: planId,
          name: plan.name,
          discount: adjustment.value || 0,
          discount_type: adjustment.value_type || "",
          fixed_price:
            adjustment.value_type === "price" ? adjustment.value : null,
        });
      }

      return normalized;
    },

    getAllocationPlanId(allocation) {
      if (!allocation) return null;
      return this.normalizePlanId(
        allocation.selling_plan_id ?? allocation.selling_plan?.id
      );
    },

    getActiveAllocation(variant) {
      if (!variant) return null;
      const allocations = variant.selling_plan_allocations || [];

      if (this.activePlanIds.size) {
        const matched = allocations.find((allocation) => {
          const planId = this.getAllocationPlanId(allocation);
          return planId != null && this.activePlanIds.has(planId);
        });
        if (matched) return matched;
      }

      const withPlanId = allocations.find(
        (allocation) => this.getAllocationPlanId(allocation) != null
      );
      return withPlanId || allocations[0] || null;
    },

    getVariantById(variantId) {
      const normalizedVariantId = this.normalizePlanId(variantId);
      return (this.mainProduct.variants || []).find(
        (item) => this.normalizePlanId(item.id) === normalizedVariantId
      );
    },

    getVariantPlanIds(variant) {
      const ids = new Set();
      const allocations = variant?.selling_plan_allocations || [];

      allocations.forEach((allocation) => {
        const planId = this.getAllocationPlanId(allocation);
        if (planId == null) return;
        if (this.activePlanIds.size && !this.activePlanIds.has(planId)) return;
        ids.add(planId);
      });

      return ids;
    },

    getAvailableSellingPlans(variantId = this.selectedVariant) {
      const plans = this.subscriptionDataObj?.selling_plans || [];
      if (!plans.length) return [];

      const variant = this.getVariantById(variantId);
      if (!variant) return plans;

      const variantPlanIds = this.getVariantPlanIds(variant);
      if (!variantPlanIds.size) return plans;

      return plans.filter((plan) => variantPlanIds.has(plan.id));
    },

    isSellingPlanAvailableForVariant(planId, variantId = this.selectedVariant) {
      const normalizedPlanId = this.normalizePlanId(planId);
      if (normalizedPlanId == null) return false;

      return this.getAvailableSellingPlans(variantId).some(
        (plan) => plan.id === normalizedPlanId
      );
    },

    onSellingPlanChange(planId) {
      const normalizedPlanId = this.normalizePlanId(planId);
      if (this.isSellingPlanAvailableForVariant(normalizedPlanId)) {
        this.selectedSellingPlanId = normalizedPlanId;
        this.planChosen = true;
      }
    },

    resolveSellingPlanId(variantId) {
      this.setSellingPlanForVariant(variantId, this.selectedSellingPlanId);
      return this.selectedSellingPlanId;
    },

    setSellingPlanForVariant(variantId, preferredPlanId = null) {
      const plans = this.subscriptionDataObj?.selling_plans || [];
      const normalizedPreferredPlanId = this.normalizePlanId(preferredPlanId);
      const variant = this.getVariantById(variantId);
      const allocation = this.getActiveAllocation(variant);

      if (!plans.length) {
        const allocationPlanId = this.getAllocationPlanId(allocation);
        this.selectedSellingPlanId =
          allocationPlanId ?? this.fallbackSellingPlanId;
        return;
      }

      if (
        normalizedPreferredPlanId != null &&
        this.isSellingPlanAvailableForVariant(normalizedPreferredPlanId, variantId)
      ) {
        this.selectedSellingPlanId = normalizedPreferredPlanId;
        return;
      }

      const allocationPlanId = this.getAllocationPlanId(allocation);
      const availablePlans = this.getAvailableSellingPlans(variantId);
      const matchedPlan = availablePlans.find((plan) => plan.id === allocationPlanId);

      if (matchedPlan) {
        this.selectedSellingPlanId = matchedPlan.id;
        return;
      }

      const fallbackMatched = availablePlans.find(
        (plan) => plan.id === this.fallbackSellingPlanId
      );
      this.selectedSellingPlanId = fallbackMatched
        ? fallbackMatched.id
        : availablePlans[0]?.id ?? plans[0].id;
    },

    parseVariantMediaMap() {
      const rawJson = this.$refs.variantMediaMap?.textContent;
      if (!rawJson) return;
      try {
        this.variantMediaMap = JSON.parse(rawJson);
      } catch (e) {
        this.variantMediaMap = {};
      }
    },

    slideToVariantImage(variantId) {
      if (!this.sectionId) return;
      const mediaId = this.variantMediaMap[String(variantId)];
      if (!mediaId) return;

      const mainEl = document.querySelector("#ctr-pb-main-" + this.sectionId);
      if (!mainEl || !mainEl.swiper) return;

      const slides = Array.from(mainEl.querySelectorAll(".swiper-slide"));
      const targetIndex = slides.findIndex(
        (slide) => slide.dataset.mediaId === String(mediaId)
      );

      if (targetIndex !== -1) {
        mainEl.swiper.slideTo(targetIndex);
      }
    },

    parseVariantData() {
      const rawJson = this.$refs.variantDataMap?.textContent;
      if (!rawJson) return;
      try {
        this.variantData = JSON.parse(rawJson);
      } catch (e) {
        this.variantData = {};
      }
    },

    onVariantChange(variantId) {
      if (this.normalizePlanId(variantId) === this.normalizePlanId(this.selectedVariant)) return;
      this.selectedVariant = variantId;
      this.setSellingPlanForVariant(variantId, this.selectedSellingPlanId);
      if (this.sub3Enabled) this.setSub3PlanForVariant();
      this.applyVariantBg(variantId);
      this.updateUrl();
      this.dispatchVariantChange(variantId);
      this.renderGallery(variantId);
    },

    // Only a CSS variable changes; energy sections read var(--ctr-energy-pdp-bg).
    applyVariantBg(variantId) {
      if (!this.useVariantBg) return;
      const color = this.variantData[String(variantId)]?.bg || this.bgFallback;
      const root = document.documentElement;
      if (color) root.style.setProperty('--ctr-energy-pdp-bg', color);
      else root.style.removeProperty('--ctr-energy-pdp-bg');
    },

    // URL always holds the main product variant id (also in 3 pack modes).
    updateUrl() {
      const variantId = this.selectedVariant;
      if (!variantId) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState(window.history.state, '', url.toString());
    },

    // theme:variant:change is consumed by ctr-energy-why-spray (and any other listener).
    dispatchVariantChange(variantId) {
      const variant = this.variantData[String(variantId)] || { id: variantId };
      document.dispatchEvent(new CustomEvent('theme:variant:change', {
        detail: { variant, sectionId: this.sectionId },
      }));
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('custom_variant_change', {
          variantId: String(variantId),
          variantTitle: variant.title || '',
          productTitle: this.mainProduct.title || '',
          price: variant.price != null ? (variant.price / 100).toFixed(2) : '',
          currency: window.Shopify?.currency?.active || 'USD',
        });
      }
    },

    // Section Rendering API: re-render this section for the variant and swap only the gallery.
    async renderGallery(variantId) {
      if (!this.sectionId) return;
      const current = this.$root.querySelector('[data-ctr-epb-gallery]');
      if (!current) return;

      const sub3Variant = this.isThreePackMode() ? this.getSub3Variant(variantId) : null;
      const useThreePack = Boolean(sub3Variant && this.threePackUrl);
      const key = useThreePack ? `3pack:${sub3Variant.id}` : `main:${variantId}`;
      if (key === this.galleryKey) return;
      const previousKey = this.galleryKey;
      this.galleryKey = key;

      if (this.galleryAbort) this.galleryAbort.abort();
      const controller = new AbortController();
      this.galleryAbort = controller;

      let url;
      if (useThreePack) {
        // Render this template's section with the 3 pack product (same gallery window logic).
        url = new URL(this.threePackUrl, window.location.origin);
        if (this.templateSuffix) url.searchParams.set('view', this.templateSuffix);
        url.searchParams.set('variant', sub3Variant.id);
      } else {
        const onProductPage = this.productUrl && window.location.pathname.endsWith(this.productUrl);
        url = new URL(onProductPage ? window.location.href : this.productUrl || window.location.href, window.location.origin);
        // Keep this template so the section exists in the response (also when previewed via ?view=).
        url.searchParams.delete('view');
        if (this.templateSuffix) url.searchParams.set('view', this.templateSuffix);
        url.searchParams.set('variant', variantId);
      }
      url.searchParams.set('section_id', this.sectionId);

      current.classList.add('is-loading');
      try {
        const response = await fetch(url.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('[data-ctr-epb-gallery]');
        if (!next) {
          this.galleryKey = previousKey;
          return;
        }

        const mainEl = current.querySelector('.ctr-pb__main-swiper');
        const thumbsEl = current.querySelector('.ctr-pb__thumbs-swiper');
        if (mainEl?.swiper) mainEl.swiper.destroy(true, true);
        if (thumbsEl?.swiper) thumbsEl.swiper.destroy(true, true);

        current.innerHTML = next.innerHTML;
        window.CtrEnergyProductBoxSwiper?.[this.sectionId]?.();
      } catch (error) {
        if (error.name !== 'AbortError') {
          if (this.galleryKey === key) this.galleryKey = previousKey;
          console.error('[ctr-epb] gallery render failed', error);
          this.slideToVariantImage(variantId);
        }
      } finally {
        if (this.galleryAbort === controller) {
          this.galleryAbort = null;
          current.classList.remove('is-loading');
        }
      }
    },

    // ── Purchase mode ──
    isThreePackMode(mode = this.mode) {
      return mode === 'subscribe3' || mode === 'onetime3';
    },

    isModeEnabled(mode) {
      // No 3 pack selling plans (provider-filtered) → the 3 Pack is one-time only.
      if (mode === 'subscribe3') return this.sub3Enabled && this.sub3OptionEnabled && this.sub3Plans.length > 0;
      if (mode === 'onetime3') return this.sub3Enabled && this.onetime3OptionEnabled;
      if (mode === 'onetime') return this.onetimeEnabled;
      return true;
    },

    // ── v2 blocks: pack (6 | 3) x purchase type (subscribe | onetime) → mode ──
    modeFor(pack, purchase) {
      if (pack === '3') return purchase === 'onetime' ? 'onetime3' : 'subscribe3';
      return purchase === 'onetime' ? 'onetime' : 'subscribe';
    },

    isPack(pack) {
      return (this.isThreePackMode() ? '3' : '6') === String(pack);
    },

    isPurchase(purchase) {
      const current = this.mode === 'onetime' || this.mode === 'onetime3' ? 'onetime' : 'subscribe';
      return current === purchase;
    },

    setPack(pack) {
      const purchase = this.isPurchase('onetime') ? 'onetime' : 'subscribe';
      let mode = this.modeFor(String(pack), purchase);
      if (!this.isModeEnabled(mode)) {
        mode = this.modeFor(String(pack), purchase === 'onetime' ? 'subscribe' : 'onetime');
      }
      this.setMode(mode);
    },

    // Purchase pills are only useful when the current pack offers both types.
    hasPurchaseChoice() {
      const pack = this.isThreePackMode() ? '3' : '6';
      return this.isModeEnabled(this.modeFor(pack, 'subscribe')) && this.isModeEnabled(this.modeFor(pack, 'onetime'));
    },

    setPurchase(purchase) {
      this.setMode(this.modeFor(this.isThreePackMode() ? '3' : '6', purchase));
    },

    isVariantDisabled(variantId) {
      const main = this.variantData[String(variantId)];
      if (!main || !main.available) return true;
      if (!this.isThreePackMode()) return false;
      const v3 = this.getSub3Variant(variantId);
      return !v3 || !v3.available;
    },

    setMode(mode) {
      if (!this.isModeEnabled(mode) || this.mode === mode) return;
      this.mode = mode;
      if (this.isThreePackMode()) this.ensureSub3Variant();
      this.updateUrl();
      // Gallery switches between main product and 3 pack product images.
      this.renderGallery(this.selectedVariant);
    },

    // ── Subscribe 3 Pack (separate product, variants matched by title) ──
    parseSub3Product() {
      const rawJson = this.$refs.sub3ProductJson?.textContent;
      if (!rawJson) {
        this.sub3Enabled = false;
        return;
      }
      try {
        this.sub3Product = JSON.parse(rawJson);
      } catch (error) {
        console.error('[ctr-epb] 3 pack product parse error', error);
        this.sub3Enabled = false;
        return;
      }
      this.sub3Plans = this.buildSellingPlans(this.sub3Product);
      this.sub3PlanIds = new Set(this.sub3Plans.map((plan) => plan.id));
      this.setSub3PlanForVariant();
    },

    getSub3Variant(variantId = this.selectedVariant) {
      const title = this.variantData[String(variantId)]?.title;
      if (title == null) return null;
      const variants = this.sub3Product.variants || [];
      // Fallback: compare flavor names only, so pack copy appended to titles
      // (e.g. "Cherry Cola 6 Bottles. 36 Servings.") doesn't break the match.
      const flavor = (t) => String(t).split(/\d/)[0].replace(/[\s\-–—|,.:(]+$/, '').trim().toLowerCase();
      return variants.find((v) => v.title === title)
        || variants.find((v) => flavor(v.title) === flavor(title))
        || null;
    },

    // Selected flavor may not exist / be sold out in the 3 pack: pick the first one that is.
    ensureSub3Variant() {
      const current = this.getSub3Variant();
      if (current && current.available) {
        this.setSub3PlanForVariant();
        return;
      }
      const match = Object.values(this.variantData).find((v) => {
        const v3 = this.getSub3Variant(v.id);
        return v.available && v3 && v3.available;
      });
      if (match) this.onVariantChange(match.id);
    },

    getSub3AvailablePlans() {
      const variant = this.getSub3Variant();
      if (!variant || !this.sub3Plans.length) return [];
      const ids = new Set();
      (variant.selling_plan_allocations || []).forEach((allocation) => {
        const planId = this.getAllocationPlanId(allocation);
        if (planId != null && this.sub3PlanIds.has(planId)) ids.add(planId);
      });
      return this.sub3Plans.filter((plan) => ids.has(plan.id));
    },

    setSub3PlanForVariant() {
      const plans = this.getSub3AvailablePlans();
      const current = this.normalizePlanId(this.selectedSub3PlanId);
      if (plans.some((plan) => plan.id === current)) return;
      const fallback = plans.find((plan) => plan.id === this.fallbackSellingPlanId);
      this.selectedSub3PlanId = (fallback || plans[0])?.id ?? null;
    },

    onSub3SellingPlanChange(planId) {
      const normalized = this.normalizePlanId(planId);
      if (this.getSub3AvailablePlans().some((plan) => plan.id === normalized)) {
        this.selectedSub3PlanId = normalized;
      }
    },

    // ── Prices (used when "Override prices with static text" is off) ──
    applyPlanAdjustment(price, plan) {
      if (price == null || !plan) return price;
      const value = Number(plan.discount) || 0;
      if (plan.discount_type === 'percentage') return Math.round(price * (100 - value) / 100);
      if (plan.discount_type === 'fixed_amount') return Math.max(0, price - value);
      if (plan.discount_type === 'price') return plan.fixed_price ?? value;
      return price;
    },

    getOriginal(price, variant, basePrice) {
      const candidates = [variant?.compare_at_price, basePrice].filter((p) => p && p > price);
      return candidates.length ? Math.max(...candidates) : null;
    },

    getSubPrice() {
      const variant = this.getVariantById(this.selectedVariant);
      if (!variant) return null;
      const planId = this.normalizePlanId(this.selectedSellingPlanId);
      // Updated layout: Shopify's own allocation price for the plan (exact for fixed amount off).
      if (this.updatedLayout) {
        const allocation = (variant.selling_plan_allocations || []).find(
          (item) => this.normalizePlanId(item.plan_id) === planId
        );
        if (allocation && allocation.price != null) return allocation.price;
      }
      const plan = (this.subscriptionDataObj.selling_plans || []).find(
        (item) => item.id === planId
      );
      return this.applyPlanAdjustment(variant.price, plan);
    },

    getSubOriginalPrice() {
      const variant = this.getVariantById(this.selectedVariant);
      const price = this.getSubPrice();
      return variant && price != null ? this.getOriginal(price, variant, variant.price) : null;
    },

    getOnetimePrice() {
      return this.getVariantById(this.selectedVariant)?.price ?? null;
    },

    getOnetimeOriginalPrice() {
      const variant = this.getVariantById(this.selectedVariant);
      return variant ? this.getOriginal(variant.price, variant, null) : null;
    },

    getSub3Price() {
      const variant = this.getSub3Variant();
      if (!variant) return null;
      const plan = this.getSub3AvailablePlans().find(
        (item) => item.id === this.normalizePlanId(this.selectedSub3PlanId)
      );
      return this.applyPlanAdjustment(variant.price, plan);
    },

    getSub3OriginalPrice() {
      const variant = this.getSub3Variant();
      const price = this.getSub3Price();
      return variant && price != null ? this.getOriginal(price, variant, variant.price) : null;
    },

    getOnetime3Price() {
      return this.getSub3Variant()?.price ?? null;
    },

    getOnetime3OriginalPrice() {
      const variant = this.getSub3Variant();
      return variant ? this.getOriginal(variant.price, variant, null) : null;
    },

    getPriceFor(mode = this.mode) {
      if (mode === 'subscribe3') return this.getSub3Price();
      if (mode === 'onetime3') return this.getOnetime3Price();
      if (mode === 'onetime') return this.getOnetimePrice();
      return this.getSubPrice();
    },

    getOriginalPriceFor(mode = this.mode) {
      if (mode === 'subscribe3') return this.getSub3OriginalPrice();
      if (mode === 'onetime3') return this.getOnetime3OriginalPrice();
      if (mode === 'onetime') return this.getOnetimeOriginalPrice();
      return this.getSubOriginalPrice();
    },

    // Price per serving: current (discounted) price divided by the pack servings.
    getServingPrice() {
      const price = this.getPriceFor();
      if (price == null) return null;
      const servings = this.isThreePackMode() ? this.threePackServings : this.sixPackServings;
      return Math.round(price / servings);
    },

    formatServings(template) {
      const price = this.getServingPrice();
      if (price == null) return '';
      return String(template || '[price]').replace('[price]', this.formatMoney(price));
    },

    formatMoney(cents) {
      if (cents == null || cents === '') return '';
      const value = Number(cents) / 100;
      const format = (decimals, thousands, decimal) => {
        const [int, dec] = value.toFixed(decimals).split('.');
        const withThousands = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return dec ? withThousands + decimal + dec : withThousands;
      };
      return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals': return format(0, ',', '.');
          case 'amount_with_comma_separator': return format(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return format(0, '.', ',');
          case 'amount_with_apostrophe_separator': return format(2, "'", '.');
          default: return format(2, ',', '.');
        }
      });
    },

    // Money without trailing zeros ($40 rather than $40.00), as in the updated layout's Figma.
    formatPrice(cents) {
      return this.formatMoney(cents).replace(/[.,]00(?=\D*$)/, '');
    },

    // Badge text with [percent] / [amount] = saving against the one-time price (subscribe modes)
    // or the compare-at price (one-time modes). Empty when there is no saving, so the badge hides.
    formatBadge(template, mode = this.mode) {
      const price = this.getPriceFor(mode);
      if (price == null) return '';
      const isSub = mode === 'subscribe' || mode === 'subscribe3';
      const isThree = this.isThreePackMode(mode);
      const variant = isThree ? this.getSub3Variant() : this.getVariantById(this.selectedVariant);
      const base = isSub ? variant?.price : variant?.compare_at_price;
      if (!base || base <= price) return '';
      const saving = base - price;
      return String(template)
        .replace('[percent]', String(Math.round((saving / base) * 100)))
        .replace('[amount]', this.formatPrice(saving));
    },

    addToCart() {
      if (!this.selectedVariant || this.loading) return;

      this.loading = true;

      const t0 = performance.now();
      const log = (label) => console.log(`[ctr-epb] ${label}: +${Math.round(performance.now() - t0)}ms`);
      log('click');

      let mainItem = { id: this.selectedVariant, quantity: 1 };
      let atcProduct = this.mainProduct;
      if (this.isThreePackMode()) {
        // subscribe3: subscription when its selling plans exist, otherwise one-time. onetime3: always one-time.
        const sub3Variant = this.getSub3Variant();
        if (!sub3Variant || !sub3Variant.available) {
          this.loading = false;
          return;
        }
        mainItem = { id: sub3Variant.id, quantity: 1 };
        atcProduct = this.sub3Product;
        if (this.mode === "subscribe3") {
          this.setSub3PlanForVariant();
          if (this.selectedSub3PlanId) mainItem.selling_plan = this.selectedSub3PlanId;
        }
      } else if (this.mode === "subscribe") {
        const sellingPlanId = this.resolveSellingPlanId(this.selectedVariant);
        if (sellingPlanId) {
          mainItem.selling_plan = sellingPlanId;
        } else {
          console.warn(
            "[ctr-epb] subscribe ATC without selling_plan",
            {
              provider: this.subscriptionProvider,
              variantId: this.selectedVariant,
              plans: this.subscriptionDataObj?.selling_plans,
            }
          );
        }
      }

      const items = [mainItem];
      if (this.mode === "subscribe" || this.mode === "subscribe3") {
        const giftPropKey = this.giftPropertyKey;
        const giftPropValue = this.giftPropertyValue;
        this.giftVariants.forEach(function(variantId) {
          const props = {};
          props[giftPropKey] = giftPropValue;
          items.push({
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: props
          });
        });
      }

      if (this.insuredShippingVariant) {
        items.push({
          id: this.insuredShippingVariant,
          quantity: 1,
          properties: { '_insured_shipping': 'true' }
        });
      }

      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .then(function(r) { log('clear done'); return r.json(); })
        .then(() => {
          log('add start');
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }),
          });
        })
        .then((r) => {
          log('add done');
          // Updated layout: a rejected add (e.g. 422 sold out) must not send the shopper to an empty checkout.
          if (this.updatedLayout && !r.ok) {
            return r.json().catch(() => ({})).then((body) => {
              throw new Error(body.description || body.message || `add failed (${r.status})`);
            });
          }
          return r.json();
        })
        .then(() => {
          log('redirect');
          // Fire ATC event for paid product only
          const variant = (atcProduct.variants || []).find(
            (v) => this.normalizePlanId(v.id) === this.normalizePlanId(mainItem.id)
          );
          if (variant && window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish('custom_add_to_cart', {
              variantId: String(mainItem.id),
              productTitle: atcProduct.title || '',
              price: (variant.price / 100).toFixed(2),
              currency: window.Shopify?.currency?.active || 'USD',
              quantity: 1
            });
            console.log('[ctr-epb] ATC published for:', atcProduct.title);
          }

          if (this.redirectAfterAdd === 'checkout') window.location.href = '/checkout';
          else if (this.redirectAfterAdd === 'cart') window.location.href = '/cart';
          else this.loading = false;
        })
        .catch((error) => {
          console.error("[ctr-epb] cart error", error);
          this.loading = false;
        });
    },
  }));
});
